import { enableProdMode, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';

import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { RouteReuseStrategy } from '@angular/router';
import Aura from '@primeng/themes/aura';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { DialogService } from 'primeng/dynamicdialog';
import { AppRoutingModule } from './app/app-routing.module';
import { AppComponent } from './app/app.component';
import { authInterceptor } from './app/interceptors/auth-interceptor';
import { spinnerInterceptor } from './app/interceptors/spinner-interceptor';
import { AuthService } from './app/services/authentication/auth-service';
import { ErrorHandlerService } from './app/services/error-handler/error-handler';
import { environment } from './environments/environment';

export function initApp(authService: AuthService) {
  return () => authService.loadUserFromStorage();
}

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(BrowserModule, AppRoutingModule),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: '.dark-mode'
        }
      },
      ripple: true
    }),

    // provideHttpClient(),
    provideHttpClient(withInterceptors([authInterceptor, spinnerInterceptor]), withInterceptorsFromDi()),
    provideAppInitializer(async () => {
      const auth = inject(AuthService);
      // const translationService = inject(TranslationService);
      // const langId = translationService.getLocalStorage();
      // await translationService.init(langId);
      auth.loadUserFromStorage();
    }),
    {
      provide: RouteReuseStrategy,
      useClass: class extends RouteReuseStrategy {
        shouldDetach() {
          return false;
        }
        store() {}
        shouldAttach() {
          return false;
        }
        retrieve() {
          return null;
        }
        shouldReuseRoute() {
          return false;
        }
      }
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerService,
      multi: true
    },
    DialogService,
    MessageService,
    DatePipe
    // ProgressSpinnerModule
  ]
}).catch((err) => console.error(err));
